import { useQuery } from '@tanstack/react-query';
import { getTokenUsageOverview, TokenUsageOverview } from 'api/adminCopilot';

export const copilotAdminQueryKey = ['copilotAdminTokenUsage'] as const;

export const useTokenUsageOverview = (days: number) => {
  return useQuery<TokenUsageOverview>([...copilotAdminQueryKey, days], () => getTokenUsageOverview(days), {
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  });
};
